import styled from "styled-components";

export const CourseList = styled.ul`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0;
  width: 100%;

  :empty:before {
    content: "No courses to display";
  }
`;

export const CourseItem = styled.li`
  display: flex;
  flex-direction: column;
  font-size: ${({ theme }) => theme.fontSizes.regular};
  .title {
    width: 65%;
  }
`;
export const LocaleContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
export const LocaleItem = styled.li<{ isMaster: boolean }>(
  ({ isMaster, theme }) => `
    display: flex;
    align-items: center;
    box-sizing: border-box;
    margin: 0 0.25rem 0.5rem 0rem;
    padding: 0.3em 0.5em;
    border: 0.1rem solid ${theme.colors.lightsilver};
    border-bottom: ${isMaster && `0.3rem solid ${theme.colors.defaultTheme}`};
    border-radius: 0.5rem;
    color: ${theme.colors.lightsilver};
    background-color: ${theme.colors.white};
    font-size: ${theme.fontSizes.small};
    white-space: nowrap;
  `
);

export const ClassList = styled.ul`
  display: flex;
  flex-direction: row;
  padding: 0;
  font-size: ${({ theme }) => theme.fontSizes.small};
`;

export const ClassItem = styled.li`
  display: flex;
  flex-direction: row;
  margin-bottom: 0.08rem;
  width: 100%;
  flex-wrap: wrap;
`;

export const ScormPackageList = styled.ul`
  display: flex;
  padding: 0;
  font-size: ${({ theme }) => theme.fontSizes.small};
`;

export const ScormPackageItem = styled.li`
  display: flex;
  flex-direction: row;
  margin-bottom: 0.08rem;
  flex-wrap: wrap;
`;
export const DashboardIcon = styled.div`
  display: flex;
  margin-right: 1rem;
  font-size: 2rem;
  height: 1.3em;
  svg {
    height: inherit;
    width: inherit;
  }
`;
export const SCORMPackageDashboardIcon = styled(DashboardIcon)``;
export const LanguageDashboardIcon = styled(DashboardIcon)`
  padding-top: 0.2rem;
`;

export const Subtle = styled.div`
  display: flex;
  width: 100%;
`;
export const ScormPackageTagContainer = styled.div`
  display: block;
  width: 50%;
`;
export const ScormPackageTag = styled.div`
  border: 0.1rem solid ${({ theme }) => theme.colors.lightsilver};
  margin: 0.5rem 0.25rem;
  border-radius: 0.5rem;
  color: ${({ theme }) => theme.colors.lightsilver};
  padding: 0.3em 0.5em;
  font-size: ${({ theme }) => theme.fontSizes.small};
  display: inline-block;
`;

export const LinksContainer = styled.div`
  display: flex;
  margin-left: auto;
  margin-right: 0;
  width: 50%;
  align-items: center;
`;

export const ExternalLink = styled.a`
  text-decoration: none;
`;
export const TextSpan = styled.span`
  margin-left: 0.25rem;
  display: flex;
  align-items: center;
`;
export const ContentList = styled.span`
  width: 100%;
`;
